import axios from "axios";
import { toast } from "react-toastify";

// No need to return the token on the frontend anymore because it is stored as an HttpOnly cookie

// Register
export const register = async (user) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API}/register`, user);
    const { emailVerificationCode } = response.data;
    const { file } = response.data;

    // Return the original response along with the email verification code
    return { response, emailVerificationCode, file };
  } catch (error) {
    throw error;
  }
};

// Login
export const login = async (user) => {
  try {
    // Login will not return a token, it will store it in the HttpOnly cookie
    const response = await axios.post(`${process.env.REACT_APP_API}/login`, user, {
      withCredentials: true, // Important to send and receive cookies
    });

    // The response data may include user info, but we do not need to handle the token
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Login with reCAPTCHA
export const loginWithRecaptcha = async (user) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API}/login`, user, {
      withCredentials: true, // Important to send and receive cookies
    });

    // Return the response data
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Forgot Password
export const forgotPassword = async (email) => {
  try {
    console.log("Email to send to the backend:", email); // Debugging line
    const response = await axios.post(
      `${process.env.REACT_APP_API}/forgot/password`,
      { email }
    );

    // Display success message to the user
    toast.success(response.data.message);
  } catch (err) {
    // Display error message to the user
    toast.error(err.response.data.message || "Error occurred");
    throw err;
  }
};

// Reset Password
export const resetPassword = async (resetCode, newPassword) => {
  try {
    // Send the reset code and new password to the backend for processing
    const response = await axios.post(
      `${process.env.REACT_APP_API}/reset/password`,
      { resetCode, newPassword }
    );

    // Display success message to the user
    toast.success(response.data.message);
  } catch (err) {
    // Display error message to the user
    toast.error(err.response.data.message || "Error occurred");
    throw err;
  }
};

// Logout
export const logout = async () => {
  try {
    // Make a request to logout endpoint, which will clear the HttpOnly cookie
    const response = await axios.post(`${process.env.REACT_APP_API}/logout`, {}, {
      withCredentials: true, // Important to send and receive cookies
    });

    toast.success(response.data.message || "Logout successful");
  } catch (error) {
    toast.error(error.response.data.message || "Error during logout");
    throw error;
  }
};

// Auth check to see if the user is authenticated (optional for session validation)
// export const checkSession = async () => {
//   try {
//     const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//       withCredentials: true, // Send cookies with the request
//     });

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };



export const checkSession = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
      withCredentials: true, // Ensure cookies are sent
    });

    console.log("🔍 Raw session response:", response); // Full debug
    console.log("[AuthAction][checkSession] raw response.data →", response.data);

    if (response.data && response.data.isAuthenticated && response.data.user) {
      const { user } = response.data;

      const sessionData = {
        isAuthenticated: true,
        hasSubscribed: user.hasSubscribed || false,
        sessionId: user.sessionId || null,
        subscriberId: user.id,
        author: user.author || user.name,
        email: user.email,
        accountType: user.accountType,
        // ⭐ Passed through so App.js can gate system-admin-only UI (e.g. the
        // AI Agent Token Cost Governance dashboard) without a separate call.
        // Present only for Admin accounts — undefined for User/Subscriber,
        // which is fine since callers should already be checking accountType.
        systemRole: user.systemRole || null,
      };

      // ✅ Confirm values before returning
      console.log("✅ Extracted Session Info:", sessionData);
      console.log("[AuthAction][checkSession] → sessionData (returned to AuthWrapper) →", sessionData);

      return sessionData;
    } else {
      console.log("❌ No authenticated session found.");
      console.log("[AuthAction][checkSession] → not authenticated, returning null");
      return null;
    }
  } catch (err) {
    console.error("🚨 Error in session check:", err);
    console.error("[AuthAction][checkSession] → threw, returning null:", err?.message);
    return null;
  }
};